import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpService {
  private http = inject(HttpClient);

  /**
   * GET request
   * @param url Endpoint URL
   * @param params Query parameters
   */
  get<T>(url: string, params?: Record<string, any>): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    return this.http.get<T>(url, { params: httpParams });
  }

  /**
   * POST request
   * @param url Endpoint URL
   * @param body Payload
   */
  post<T>(url: string, body: unknown): Observable<T> {
    return this.http.post<T>(url, body);
  }

  /**
   * POST request with options (for file upload, progress, etc)
   * @param url Endpoint URL
   * @param body Payload
   * @param options Extra HTTP options (headers, observe, reportProgress, etc)
   */
  postWithOptions<T>(url: string, body: unknown, options: any): Observable<T> {
    // Use HttpClient directly to support all options
    return (this.http as any).post(url, body, options);
  }

  /**
   * PUT request
   * @param url Endpoint URL
   * @param body Payload
   */
  put<T>(url: string, body: unknown): Observable<T> {
    return this.http.put<T>(url, body);
  }

  /**
   * PATCH request
   * @param url Endpoint URL
   * @param body Payload
   */
  patch<T>(url: string, body: unknown): Observable<T> {
    return this.http.patch<T>(url, body);
  }

  /**
   * DELETE request
   * @param url Endpoint URL
   * @param params Query parameters
   */
  delete<T>(url: string, params?: Record<string, unknown>): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        httpParams = httpParams.set(key, params[key]);
      });
    }
    return this.http.delete<T>(url, { params: httpParams });
  }
}
